// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"870":"c93b168e","943":"d069aedc"}[chunkId] + ".chunk.js");